export class Link {
    constructor(display, icon, path, qs) {
        this.display = display;
        this.icon = icon;
        this.path = path;
        this.qs = qs || "";
    }
    get isActive() {
        return this.path === window.location.pathname && this.qs === window.location.search;
    }
}
//# sourceMappingURL=link.js.map